import React, { Component } from 'react';
import Particles from 'react-particles-js';
import Signin from './components/Signin/Signin';
import Register from './components/Register/Register';
import Navigation from './components/Navigation/Navigation';
// import Logo from './components/Logo/Logo';
import Rank from './components/Rank/Rank';
import ImageLinkForm from './components/ImageLinkForm/ImageLinkForm';
import FaceScan from './components/FaceScan/FaceScan';
import './App.css';

const particlesOptions={
  particles: {
    number: {
      value: 80,
      density: {
        enable: true,
        value_area: 500
      }
    }
  },
    interactivity: {
      "detect_on": "window",
      "events": {
        "onhover": {
          "enable": true,
          "mode": "repulse"
        },
  }  
}
}

const initialState = {
  input:'',
      imageUrl: '',
      box: {},
      //this is to route us to the proper sigin before they can access the home page
      route: 'signin',
      isSignedIn: false,
      user: {
        id: '',
        name: '',
        email: '',
        entries: 0,
        joined: ''
      }
    }
  
class App extends Component {
  constructor() {
    super();
    this.state = initialState;
  }

  loadUser = (data) => {
    this.setState({user: {
      id: data.id,
      name: data.name,
      email: data.email,
      entries: data.entries,
      joined: data.joined
    }})
  }
  
  calculateFaceLocation =(data) => {
    const clarifaiFace = data.outputs[0].data.regions[0].region_info.bounding_box;
    const image = document.getElementById('inputimage');
    const width = Number(image.width);
    const height = Number(image.height);
    return{
      leftCol: clarifaiFace.left_col * width,
      topRow: clarifaiFace.top_row * height,
      rightCol: width - (clarifaiFace.right_col * width),
      bottomRow: height - (clarifaiFace.bottom_row * height)
    }//this is needed to return the four corners of the box
  }

  displayFaceBox = (box) => {
    console.log(box);
    this.setState({box: box});
  }

  onInputChange = (event) => {
    this.setState({input: event.target.value});
  }

  onButtonSubmit =() => {
    this.setState({imageUrl: this.state.input});
    fetch ('http://localhost:3000/imageurl', {
      method: 'post',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        input: this.state.input
      })
    })
    .then(response => response.json())
    .then(response => {
      if (response){
        fetch('http://localhost:3000/image', {
          method: 'put',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            id: this.state.user.id
          })
        })
        .then(response => response.json())
        .then(count => {
          this.setState(Object.assign(this.state.user, { entries: count}))
        })
        .catch(console.log)

      }
      this.displayFaceBox (this.calculateFaceLocation(response))
    })
    .catch(err => console.log(err));
  }
  
    onRouteChange = (route) => {
      if (route === 'signout') {
        this.setState(initialState)
      } else if (route === 'home'){
        this.setState({isSignedIn: true})
      }
      this.setState({route: route});
    }

  render() {
    const {isSignedIn, imageUrl, route, box} = this.state; //use destructuring so we don't have to use this.state so many times
    return (
      <div className="App">
        <Particles className='particles'
            params={particlesOptions}/>
      
      <Navigation isSignedIn={isSignedIn} onRouteChange={this.onRouteChange}/>
      {/*We create a state that routes us to signin*/}
      { route === 'home' ?
        <div>
        <Rank 
          name={this.state.user.name}
          entries={this.state.user.entries}
        />
        <ImageLinkForm onInputChange ={this.onInputChange}  
          onButtonSubmit={this.onButtonSubmit}/>
        <FaceScan box={box} imageUrl={imageUrl}/>
        </div>
        : (
          this.state.route === 'signin' ?
          <Signin loadUser={this.loadUser} onRouteChange={this.onRouteChange} />: 
          <Register loadUser={this.loadUser} onRouteChange={this.onRouteChange}/>
        )
      }
      </div>
  );
}
}

export default App;
